<nav class="sidebar" aria-label="Main navigation">
  <!-- Top-level items (Dashboard, Geofences) -->
  @for (item of topLevelItems; track item.label) {
    <a
      class="nav-item"
      [class.active]="isActive(item.route)"
      [routerLink]="item.route"
      [attr.aria-current]="isActive(item.route) ? 'page' : null"
    >
      <i class="nav-icon" aria-hidden="true" [class]="item.icon"></i>
      <span>{{ item.label }}</span>
    </a>
  }

  <!-- Collapsible groups -->
  @for (group of visibleNavGroups(); track group.label) {
    <div class="nav-group">
      <button
        class="group-header"
        (click)="toggleGroup(group.label)"
        [attr.aria-expanded]="isGroupExpanded(group.label)"
      >
        <span class="group-label">{{ group.label }}</span>
        <i
          class="pi"
          aria-hidden="true"
          [class.pi-chevron-down]="isGroupExpanded(group.label)"
          [class.pi-chevron-right]="!isGroupExpanded(group.label)"
        ></i>
      </button>

      @if (isGroupExpanded(group.label)) {
        <div class="group-children">
          <ng-container
            [ngTemplateOutlet]="items"
            [ngTemplateOutletContext]="{ items: group.items, parentKey: group.label, depth: 1 }"
          />
        </div>
      }
    </div>
  }
</nav>

<!-- One level of the tree: an item with children opens and closes them, any other item is a link. -->
<ng-template #items let-nodes="items" let-parentKey="parentKey" let-depth="depth">
  @for (node of nodes; track node.label) {
    @let key = itemKey(parentKey, node);
    @if (node.children?.length) {
      <button
        type="button"
        class="nav-item child branch"
        [class.on-path]="isOnActivePath(key)"
        [style.--depth]="depth"
        [attr.aria-expanded]="isGroupExpanded(key)"
        [attr.data-testid]="node.testId"
        (click)="toggleGroup(key)"
      >
        @if (node.icon) {
          <i class="nav-icon" aria-hidden="true" [class]="node.icon"></i>
        }
        <span class="nav-label">{{ node.label }}</span>
        <i
          class="pi branch-chevron"
          aria-hidden="true"
          [class.pi-chevron-down]="isGroupExpanded(key)"
          [class.pi-chevron-right]="!isGroupExpanded(key)"
        ></i>
      </button>
      @if (isGroupExpanded(key)) {
        <div class="nav-children" role="group" [attr.aria-label]="node.label">
          <ng-container
            [ngTemplateOutlet]="items"
            [ngTemplateOutletContext]="{ items: node.children, parentKey: key, depth: depth + 1 }"
          />
        </div>
      }
    } @else {
      <a
        class="nav-item child"
        [class.active]="isCurrent(key)"
        [routerLink]="node.route"
        [style.--depth]="depth"
        [attr.aria-current]="isCurrent(key) ? 'page' : null"
        [attr.data-testid]="node.testId"
      >
        @if (node.icon) {
          <i class="nav-icon" aria-hidden="true" [class]="node.icon"></i>
        }
        <span>{{ node.label }}</span>
      </a>
    }
  }
</ng-template>
